<div class="label-properties-panel">
    @if (isTouchMode) {

        <button mat-raised-button color="primary" (click)="onTouchAction()">
            <mat-icon>touch_app</mat-icon>
            Touch Action
        </button>
        <br><br>



    }
    <div fxFlex fxLayoutAlign="center center" fxLayoutGap="16px">
        <button mat-raised-button (click)="openSwapIconDialog()">
            <mat-icon>find_replace</mat-icon>
            &nbsp;{{ 'general.changeIcon' | transloco }}
        </button>
    </div>
    <br>
    <br>
    @if (dynamicsInitialized) {
        <div>
            <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
            </dynamic-form>
        </div>
    }
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
</div>

